import { useAppSelector } from '../../../store/hooks';
import { selectUser } from '../redux/selectors';

/**
 * Hook to access user roles and permissions.
 *
 * Example:
 * const { hasRole, hasPermission } = useRole();
 * if (hasRole('admin')) { ... }
 */
export const useRole = () => {
  const user = useAppSelector(selectUser);

  const hasRole = (role: string | string[]) => {
    if (!user) {
      return false;
    }
    const roles = Array.isArray(role) ? role : [role];
    return roles.some((r) => user.roles.includes(r));
  };

  const hasPermission = (permission: string | string[]) => {
    if (!user) {
      return false;
    }
    const permissions = Array.isArray(permission) ? permission : [permission];
    return permissions.some((p) => user.permissions.includes(p));
  };

  return {
    roles: user?.roles || [],
    permissions: user?.permissions || [],
    hasRole,
    hasPermission,
    isActive: user?.is_active || false,
  };
};
